import { render, staticRenderFns } from "./UserGallery.vue?vue&type=template&id=2c199f1b"
import script from "./UserGallery.vue?vue&type=script&lang=js"
export * from "./UserGallery.vue?vue&type=script&lang=js"
import style0 from "./UserGallery.vue?vue&type=style&index=0&id=2c199f1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports